exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".container-box{display:flex;flex-direction:column}.container-box .info-container{flex:1;display:flex;flex-direction:column}.container-box .info-container .transc-container{flex:1}\n", ""]);

